import { render, staticRenderFns } from "./UrgentNotificationSide.vue?vue&type=template&id=1429d796&scoped=true&"
import script from "./UrgentNotificationSide.vue?vue&type=script&lang=js&"
export * from "./UrgentNotificationSide.vue?vue&type=script&lang=js&"
import style0 from "./UrgentNotificationSide.vue?vue&type=style&index=0&id=1429d796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429d796",
  null
  
)

export default component.exports